export default [{
  copy: ['Lock your Experian Credit Report, and help stop fraudsters taking out credit in your name.'],
  iconKey: 'creditLock',
  title: 'Lock your Experian Credit Report',
}, {
  copy: ['We’ll scan millions of URLs for your personal and financial details, then alert you if anything looks fraudulent.'],
  iconKey: 'webMonitoring',
  title: 'Stay safe with web monitoring',
}, {
  copy: ['This breakdown is updated daily and can help you identify fraudulent activity then take action to protect yourself.'],
  iconKey: 'fraudReport',
  title: 'Daily Experian Fraud Report',
}, {
  copy: ['Get the most important updates sent to you with email or text alerts covering changes to your Experian Fraud Report'],
  iconKey: 'fraudAlerts',
  title: 'Experian Fraud Alerts',
}, {
  copy: ['If you’re a victim of fraud, you’ll be assigned a dedicated caseworker who’ll know what to do to get you back on track.'],
  iconKey: 'fraudSupport',
  title: 'Enhanced fraud support',
}];
